import { __decorate, __metadata } from "tslib";
import NeoModel from '../../Model/NeoModel';
import { Observable } from '../../Model/Decorators';
import { Settings } from '../../Settings';
import { Utils } from '../../Utils';
import { injectable } from 'inversify';
/**
 * Represents a list of modal components added programatically.
 * Modals will be removed from the list when they are closed by the user, and the animation has been complete.
 * A modal container will render modals based on the information in this list
 */
var ModalStore = /** @class */ (function () {
    function ModalStore() {
        this.modals = [];
    }
    ModalStore.prototype.addModal = function (title, message, modalOptions) {
        modalOptions.title = title;
        modalOptions.show = true;
        var codeModal = new CodeModal(this, message, modalOptions);
        this.modals.push(codeModal);
        return codeModal;
    };
    ModalStore.prototype.removeModal = function (modal) {
        this.modals.splice(this.modals.indexOf(modal), 1);
    };
    __decorate([
        Observable(),
        __metadata("design:type", Array)
    ], ModalStore.prototype, "modals", void 0);
    ModalStore = __decorate([
        injectable(),
        NeoModel
    ], ModalStore);
    return ModalStore;
}());
export default ModalStore;
/** Represents a modal component added programatically. */
var CodeModal = /** @class */ (function () {
    function CodeModal(store, content, options) {
        this.store = store;
        this.content = content;
        this.options = options;
        this.id = Utils.uuidv4();
        this.refreshValue = 1;
        this.options.onClose = this.interceptClick(this.options.onClose);
        if (this.options.closeButton)
            this.options.closeButton.onClick = this.interceptClick(this.options.closeButton.onClick);
        if (this.options.acceptButton)
            this.options.acceptButton.onClick = this.interceptClick(this.options.acceptButton.onClick);
        if (this.options.buttons) {
            for (var _i = 0, _a = this.options.buttons; _i < _a.length; _i++) {
                var button = _a[_i];
                button.onClick = this.interceptClick(button.onClick);
            }
        }
    }
    CodeModal.prototype.interceptClick = function (onClick) {
        var _this = this;
        return function (e) {
            _this.options.show = false;
            _this.refreshValue += 1;
            if (onClick)
                onClick(e);
            setTimeout(function () {
                _this.store.removeModal(_this);
            }, Settings.modalAnimationTimeMs);
        };
    };
    CodeModal.prototype.close = function () {
        this.options.show = false;
        this.refreshValue += 1;
    };
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], CodeModal.prototype, "refreshValue", void 0);
    CodeModal = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Object, Object, Object])
    ], CodeModal);
    return CodeModal;
}());
